import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Special_Emergenices } from '../../../../../constants/APIs';
import { getGroupID } from '../../../../../helpers/AxiosAPI';
import PublishGPT from '../components/PublishGPT/PublishGPT';
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

class SpecialEmergencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: this.props.locale,
    }
  }
  render() {
    return (
      <Fragment>
        {/* GPT Publish Button START  */}
        {/* {(getGroupID() === "a7e06370-a3bc-43ef-ba88-afb100137eca" ||
          getGroupID() === "af402810-8902-473b-a487-b04301549dac") &&
          (<PublishGPT></PublishGPT>)
        }
        {(getGroupID() !== "a7e06370-a3bc-43ef-ba88-afb100137eca" &&
          getGroupID() !== "af402810-8902-473b-a487-b04301549dac" &&
          this.props.locale === "en") &&
          (<PublishGPT></PublishGPT>)
        } */}
        {/* GPT Publish Button END  */}
        {/* <LanguageTabs
          selectedTab={this.state.selectedTab}
          setLanguage={(e) => this.setState({ selectedTab: e })}
        ></LanguageTabs> */}
        {/* <Colxx xxs="12" className="mb-2 text-right">
          <strong><hr /></strong>
        </Colxx>
        <Card>
          <CardBody> */}
        <ResponseBlockGenerator getUrl={gAPI_Special_Emergenices} lang={this.state.selectedTab} />
        {/* </CardBody>
        </Card> */}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return {
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(SpecialEmergencies));
